import React from 'react';
import { ModalBody, ServiceSelectionSubtitle } from '../styles/modalStyles';
import { ServiceCard } from './ServiceCard';
import { SelectedServicesList } from './SelectedServicesList';
import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';
import { formatPrice } from '../../../../../utils/formatPrice';
import { useAdditionalServicesContext } from '../AdditionalServicesContext';

export const ServiceSelectionStep = ({
  services,
  selectedServices,
  onServiceSelection,
  onClose,
  onProceed,
  getTotalPrice,
  isMobile = false,
}) => {
  const {
    inspectionId,
    auctionId,
    trackPreviewServiceClicked,
    trackButtonServiceClicked,
  } = useAdditionalServicesContext();

  const availableServices = services.filter(
    service => service.showCard && service.status === 'offer'
  );
  const acquiredServices = services.filter(
    service => service.showCard && (service.status === 'waiting' || service.status === 'ready')
  );

  return (
    <>
      <ModalHeader
        title="Serviços adicionais"
        onBack={onClose}
        onClose={onClose}
        showBackButton={true}
        isMobile={isMobile}
      />
      <ModalBody>
        <ServiceSelectionSubtitle>
          Escolha os serviços que deseja solicitar para esse veículo.
        </ServiceSelectionSubtitle>

        {/* Lista de serviços já adquiridos */}
        {acquiredServices.map(service => (
          <ServiceCard
            key={service.key}
            service={service}
            isSelected={true}
            showActions={false}
            showCheckIcon={true}
          />
        ))}

        {/* Lista de serviços ainda não adquiridos */}
        {availableServices.map(service => (
          <ServiceCard
            key={service.key}
            service={service}
            isSelected={selectedServices.includes(service.key)}
            onClick={() => {
              const serviceKeyMap = {
                '01': 'laudo_venda',
                '02': 'garantia',
                '03': 'cautelar',
                '04': 'visao_total',
              };
              trackPreviewServiceClicked({
                inspectionId,
                auctionId,
                serviceType: serviceKeyMap[service.key],
              });
              onServiceSelection(service.key);
            }}
            showActions={true}
          />
        ))}

        <SelectedServicesList selectedServices={selectedServices} services={services} />
      </ModalBody>
      <ModalFooter
        primaryButtonText="Solicitar Serviços"
        onPrimaryClick={() => {
          const serviceKeyMap = {
            '01': 'laudo_venda',
            '02': 'garantia',
            '03': 'cautelar',
            '04': 'visao_total',
          };
          const selectedServicesList = selectedServices.map(key => serviceKeyMap[key]);
          trackButtonServiceClicked({
            inspectionId,
            auctionId,
            totalServicesSelected: selectedServices.length,
            selectedServicesList,
          });
          onProceed();
        }}
        primaryButtonDisabled={selectedServices.length === 0}
      />
    </>
  );
};
